module.exports = __webpack_public_path__ + "static/img/indexVersion02.5292721.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexVersion02.jpg
// module id = XBPk
// module chunks = 3